import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../api-service/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currURL: string = state.url;
    const hasLogin: boolean = (this.authService.currentTokenValue != null && this.authService.hasTempPassword == false);
    const mfaEnabled: boolean = (this.authService.currentMfaRequestedValue != null && this.authService.currentMfaRequestedValue == 'true');
    const mfaVerified: boolean = (this.authService.currentMfaVerifiedValue != null && this.authService.currentMfaVerifiedValue == 'true');
    const isLoginPg: boolean = currURL.includes("login");

    if (route.data && route.data.bypassAuth === true) {
      return true; // Bypass authentication
    } else {
      if ((hasLogin && !mfaEnabled) || (hasLogin && mfaEnabled && mfaVerified))  // has login
      {
        if (isLoginPg) {

          this.router.navigate(['/dashboard']);

          return false;
        }
        
        return true;
      } else  // no login
      {
        localStorage.clear();

        if (isLoginPg == false) {

          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

          return false;
        }

        return true;
      }
    }
  }
}
